import React, { forwardRef } from 'react';
import { View } from 'react-native';
import { Stack, StackProps } from '../Stack/Stack';

export type ColumnProps = Omit<StackProps, 'direction'>;

export const Column = forwardRef<View, ColumnProps>((props, ref) => {
  return <Stack direction="column" ref={ref} {...props} />;
});
